export default __webpack_public_path__ + "static/media/20.2d01ee56.pdf";